import React from "react";

const Spinner = () => {
  return (
    <div className="container" style={{ textAlign: "center" }}>
      <div className="section">
        <div
          className="preloader-wrapper big active"
          style={{ height: 100, width: 100 }}
        >
          <div className="spinner-layer" style={{ borderColor: "#e65100" }}>
            <div className="circle-clipper left">
              <div className="circle"></div>
            </div>
            <div className="gap-patch">
              <div className="circle"></div>
            </div>
            <div className="circle-clipper right">
              <div className="circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner.js